import React, { useState, useEffect } from 'react';
import LandingFooter from '../../components/layouts/LandingFooter';
import AOS from 'aos';
import 'aos/dist/aos.css';

const BecomeVendor: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    company_name: '',
    contact_no: '',
    email: '',
    privacy_policy: false,
    newsletter: false,
  });

  useEffect(() => {
    AOS.init({ duration: 1000, delay: 300 });
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle vendor inquiry submission
    console.log('Vendor inquiry:', formData);
  };

  return (
    <>
      <div className="d-flex flex-column bg-base-light flex-center w-100 min-h-300px z-index-n1 min-h-lg-450px px-9 bg-leaves">
        <img src="/media/lemon.png" className="w-325px lemon-img position-absolute right-0 me-15 z-index-0 img-responsive" alt="" />
        <img src="/media/vegetable.png" className="vegetable-img position-absolute z-index-0 img-responsive" alt="" />
        <div className="row w-100 mx-auto">
          <div className="col-md-8 mx-auto text-center">
            <div className="mb-5 mb-lg-10 py-10 py-lg-20">
              <h1 className="text-base-dark lh-base fw-bold fs-1x fs-lg-3x mb-5 text-uppercase" data-aos="fade-up">Are you a Vendor?</h1>
              <br />
              <p className="text-base-dark fs-lg-3" data-aos="fade-up">Join Fesilah as a vendor and reach more customers.</p>
              <img src="/media/vegetable2.png" className="w-325px vegetable2-img position-absolute z-index-0 img-responsive" alt="" />
              <img src="/media/tomato.png" className="tomato-img position-absolute right-0 z-index-0 img-responsive" alt="" />
              <br />
            </div>
          </div>
        </div>
      </div>
      <img src="/media/Wave.png" className="w-100 curve" alt="" />
      <div className="mb-n10 mb-lg-n20 z-index-2 min-h-300px inner-box">
        <div className="container">
          <div className="row mt-5">
            <div className="col-12 col-md-10 mx-auto shadow bg-white mb-15 inner-content">
              <div className="row">
                <div className="col-md-6 px-15 py-10">
                  <h1 className="text-base-dark fs-5tx text-uppercase font-bold" data-aos="fade-right">Vendor Registration</h1>
                  <br />
                  <p className="fs-lg-6 text-gray-600">Fill out the form to become a vendor partner with Fesilah.</p>
                </div>
                <div className="col-md-6 p-10" data-aos="fade-left">
                  <form onSubmit={handleSubmit}>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      required
                      className="form-control custom-input border-secondary mb-8"
                      placeholder="I am..."
                    />
                    <input
                      type="text"
                      name="company_name"
                      value={formData.company_name}
                      onChange={(e) => setFormData({ ...formData, company_name: e.target.value })}
                      required
                      className="form-control custom-input border-secondary mb-8"
                      placeholder="Business Name"
                    />
                    <input
                      type="number"
                      name="contact_no"
                      value={formData.contact_no}
                      onChange={(e) => setFormData({ ...formData, contact_no: e.target.value })}
                      required
                      className="form-control custom-input border-secondary mb-8"
                      placeholder="Contact Number"
                    />
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      required
                      className="form-control custom-input border-secondary mb-8"
                      placeholder="Email Address"
                    />
                    <div className="form-check mb-5">
                      <input
                        className="form-check-input border-base"
                        type="checkbox"
                        checked={formData.privacy_policy}
                        onChange={(e) => setFormData({ ...formData, privacy_policy: e.target.checked })}
                        required
                        id="privacy_policy"
                      />
                      <label className="form-check-label" htmlFor="privacy_policy">
                        Accept Fesilah privacy policy.
                      </label>
                    </div>
                    <div className="form-check mb-5">
                      <input
                        className="form-check-input border-base"
                        type="checkbox"
                        checked={formData.newsletter}
                        onChange={(e) => setFormData({ ...formData, newsletter: e.target.checked })}
                        id="newsletter"
                      />
                      <label className="form-check-label" htmlFor="newsletter">
                        I agree to receive newsletter and information from Fesilah by email.
                      </label>
                    </div>
                    <input type="submit" value="Sign Up" className="btn w-100 p-5 fs-lg-4 btn-base rounded-pill text-uppercase" />
                  </form>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-10 mx-auto mt-10 mb-15">
              <div className="row" data-aos="zoom-in">
                <div className="col-6 text-center">
                  <img src="/media/email.png" width="60px" alt="" />
                  <p className="lead mt-3">Email Us</p>
                  <p>Email us for general queries and partnership opportunities.</p>
                  <a href="mailto:contact@saveme.ae" className="text-base">contact@saveme.ae</a>
                </div>
                <div className="col-6 text-center">
                  <img src="/media/phone.png" width="60px" alt="" />
                  <p className="lead mt-3">Call Us</p>
                  <p>Call us to speak to a member of our team.</p>
                  <a href="tel:+971 50 573 4522" dir="ltr" className="text-base">+971 50 573 4522</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LandingFooter />
    </>
  );
};

export default BecomeVendor;
















